import $ from 'jquery';

$.fn.transitionDuration = function(cb){
	var value = (parseFloat(this.css('transitionDuration')) + parseFloat(this.css('transitionDelay'))) * 1000;

	if (cb) {
		setTimeout(cb, value);
		return this;
	} else {
		return value;
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/jquery.transitionDuration.js
// module id = 10
// module chunks = 0